module.exports = __webpack_public_path__ + "static/media/011-caries.5d1ccd82.svg";